import { API } from "aws-amplify";
import { getUser } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

// TODO [Translate]

export const EMPTY_PROPERTY_MANAGER: APITypes.User = {
  id: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  roles: APITypes.ManagerRolesType.Manager,
  createdAt: "",
  updatedAt: "",
  __typename: "User",
  _version: 0,
  _lastChangedAt: 0,
};

export const getPropertyManager = async (
  userID: string
): Promise<LoaderData<APITypes.User>> => {
  try {
    const propManagerResponse = (await API.graphql({
      query: getUser,
      variables: {
        id: userID,
      },
    })) as { data?: APITypes.GetUserQuery };

    if (!propManagerResponse.data?.getUser) {
      throw new Error("No property manager found"); // TODO [Translate]
    }

    return {
      success: true,
      data: propManagerResponse.data.getUser ?? EMPTY_PROPERTY_MANAGER,
    };
  } catch (error: any) {
    // message.error(error.message);
    console.error("get property manager", error);
    return {
      success: false,
      data: EMPTY_PROPERTY_MANAGER,
      error,
    };
  }
};
